import { useLocation, useNavigate } from "react-router-dom";
import { disablePageScroll, enablePageScroll } from "scroll-lock";
import { Link } from "react-router-dom";
import BafarLabs from "../assets/logow.png";
import { navigation } from "../constants";
import Button from "./Button";
import MenuSvg from "../assets/svg/MenuSvg";
import { HamburgerMenu } from "./design/Header";
import { useState } from "react";
import { HashLink } from "react-router-hash-link";
import { socials } from "../constants";

const Header = () => {
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();
  const [openNavigation, setOpenNavigation] = useState(false);

  // Toggle mobile navigation
  const toggleNavigation = () => {
    if (openNavigation) {
      setOpenNavigation(false);
      enablePageScroll();
    } else {
      setOpenNavigation(true);
      disablePageScroll();
    }
  };

  // Handle navigation click
  const handleClick = (url) => {
    if (!openNavigation) return;

    enablePageScroll();
    setOpenNavigation(false);

    if (url.startsWith("#")) {
      // Handle same-page anchor navigation
      const section = document.querySelector(url);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else if (url.includes("#")) {
      // Handle cross-page anchor navigation
      navigate(url);
    } else {
      // Standard navigation
      navigate(url);
    }
  };

  return (
    <div
      className={`fixed left-0 top-0 z-50 w-full border-b border-n-6 lg:bg-n-8/90 lg:backdrop-blur-sm ${
        openNavigation ? "bg-n-8" : "bg-n-8/90 backdrop-blur-sm"
      }`}
    >
      <div className="flex items-center px-5 max-lg:py-4 lg:px-7.5 xl:pl-5 2xl:px-10">
        {/* Logo */}
        <HashLink
          smooth
          to="/#hero"
          className="flex w-[12rem] lg:w-[9rem] xl:w-[9rem]"
        >
          <img src={BafarLabs} width={190} height={40} alt="Bafarlabs" />
        </HashLink>

        {/* Navigation */}
        <nav
          className={`${
            openNavigation ? "flex" : "hidden"
          } fixed bottom-0 left-0 right-0 top-[5rem] bg-n-8 lg:static lg:mx-auto lg:flex lg:bg-transparent`}
        >
          <div className="relative z-2 m-auto flex flex-col items-center justify-center lg:mx-2 lg:flex-row">
            {navigation.map((item) =>
              item.url.includes("#") ? (
                <HashLink
                  smooth
                  to={item.url}
                  key={item.id}
                  onClick={() => handleClick(item.url)}
                  className={`relative block text-center font-code text-2xl uppercase text-n-1 transition-colors hover:bg-white hover:text-black ${
                    item.onlyMobile ? "lg:hidden" : ""
                  } px-6 py-6 md:py-8 lg:-mr-0.25 lg:px-3 lg:text-sm lg:font-semibold min-[1100px]:px-4 xl:text-base ${
                    hash === item.url ? "z-2 lg:text-n-1" : "lg:text-n-1"
                  } lg:text-nowrap lg:leading-5 lg:hover:text-black xl:px-6 2xl:text-nowrap 2xl:px-8`}
                >
                  {item.title}
                </HashLink>
              ) : (
                <Link
                  to={item.url}
                  key={item.id}
                  onClick={() => handleClick(item.url)}
                  className={`relative block text-center font-code text-2xl uppercase text-n-1 transition-colors hover:bg-white hover:text-black ${
                    item.onlyMobile ? "lg:hidden" : ""
                  } px-6 py-6 md:py-8 lg:-mr-0.25 lg:px-4 lg:text-sm lg:font-semibold xl:text-[15px] xl:leading-[22px] ${
                    pathname === item.url ? "z-2 lg:text-n-1" : "lg:text-n-1"
                  } lg:text-nowrap lg:leading-5 lg:hover:text-black xl:px-6 2xl:text-nowrap 2xl:px-8`}
                >
                  {item.title}
                </Link>
              ),
            )}
          </div>

          {/* Social Icons */}

          {/* Hamburger Menu for Mobile */}
          <HamburgerMenu />
        </nav>
        <ul
          className={`${
            openNavigation ? "hidden" : "flex"
          } hidden items-center justify-center gap-1 lg:flex 2xl:gap-3`}
          role="list"
          aria-label="Social media links"
        >
          {socials.slice(0, 4).map((item) => (
            <li key={item.id} role="listitem">
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-7 w-7 items-center justify-center rounded-full bg-n-7 transition-colors hover:bg-n-6 lg:h-6 lg:w-6 2xl:h-8 2xl:w-8"
              >
                <img
                  src={item.iconUrl}
                  alt={`Icon for ${item.title}`}
                  width={14}
                  height={14}
                  className="2xl:h-4 2xl:w-4"
                />
              </a>
            </li>
          ))}
        </ul>

        {/* Mobile Menu Toggle Button */}
        <Button
          aria-expanded={openNavigation ? "true" : "false"}
          className="ml-auto lg:hidden"
          px="px-3"
          onClick={toggleNavigation}
          name="Mobile Toggle Button"
        >
          <MenuSvg openNavigation={openNavigation} />
        </Button>
      </div>
    </div>
  );
};

export default Header;
